import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ServiceProviderService } from '../../services/service-provider.service';
import { LoggingService } from '../../services/logging.service';

@Component({
  selector: 'app-service-provider-list',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './service-provider-list.component.html',
  styleUrls: ['./service-provider-list.component.css']
})
export class ServiceProviderListComponent implements OnInit {
  serviceProviders: any[] = [];
  service: string | null = '';
  locationError: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private serviceProviderService: ServiceProviderService,
    private loggingService: LoggingService
  ) { }

  ngOnInit(): void {
    this.service = this.route.snapshot.paramMap.get('service');
    if (this.service) {
      this.loggingService.logEvent('search', { search_term: this.service });
      this.serviceProviderService.getServiceProviders().subscribe(data => {
        this.serviceProviders = data.filter(item => item.field_service_provided.toLowerCase().includes(this.service?.toLowerCase()));
        this.getLocation();
      });
    }
  }

  getLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat1 = position.coords.latitude;
        const lon1 = position.coords.longitude;
        this.serviceProviders.forEach(provider => {
          const lat2 = provider.field_latitude;
          const lon2 = provider.field_longitude;
          provider.distance = this.getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2).toFixed(2);
        });
      }, (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            this.locationError = "You denied the request for Geolocation.";
            break;
          case error.POSITION_UNAVAILABLE:
            this.locationError = "Location information is unavailable.";
            break;
          case error.TIMEOUT:
            this.locationError = "The request to get user location timed out.";
            break;
          default:
            this.locationError = "An unknown error occurred.";
            break;
        }
      });
    } else {
      this.locationError = "Geolocation is not supported by this browser.";
    }
  }

  getDistanceFromLatLonInKm(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
      ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }

  deg2rad(deg: number) {
    return deg * (Math.PI / 180);
  }
}
